export const getSessionStorageItem = (key) => {
	try {
		if (typeof window === 'undefined') return null;

		return window.sessionStorage.getItem(key);
	} catch {
		return null;
	}
};

export const setSessionStorageItem = (key, value) => {
	try {
		if (typeof window === 'undefined') return null;

		window.sessionStorage.setItem(key, value);
	} catch {
		return null;
	}
};
